// extracted by mini-css-extract-plugin
export default {"container":"connect_container__jmFgq"};